module.exports = __webpack_public_path__ + "VA.png?345a7006b2073c665b6ab6069ffc083b";